import { useState, useEffect } from "react";
import Title from "../../components/Common/Title";

function ApexBuilderPage() {
  const title = "Apex Builder";
  return <Title title={title} />;
}

export default ApexBuilderPage;
